<script>
  import { onDestroy, onMount, tick } from "svelte";
  import DialogBase2 from "../dialog/DialogBase2.svelte";
  import DialogTitle from "../dialog/DialogTitle.svelte";
  import DialogSplitter from "../dialog/DialogSplitter.svelte";
  import DialogContent from "../dialog/DialogContent.svelte";
  import DialogBottomControls from "../dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../dialog/DialogBottomControlButton.svelte";
  import SearchInput from "../input/SearchInput.svelte";
  import { translate } from "../../i18n/i18next.js";

  /**
   * Function to be called when "Close" button is pressed.
   * @function
   */
  export let onClose

  /**
   * Name of the target to be filtered.
   * @type {string}
   */
  export let target

  /**
   * Translation key for the name of the target
   * @type {string}
   */
  export let targetTranslationKey = ""

  export let onFilterDetermined

  export let items = []

  export let matcher = (item, query) => {
    return typeof item.text === "string" && item.text.toLowerCase().indexOf(query.toLowerCase()) !== -1
  }

  function getFilteredItems(items, query) {
    if (!query) return items.filter(item => item.displayed)
    return items.filter(item => item.displayed).filter(item => matcher(item, query))
  }

  let query = ""
  $: filteredItems = getFilteredItems(items, query)

  function isChecked(item) {
    return !item.excluded
  }

  function setCheckedStates(items, checked) {
    for (const item of items) {
      item.excluded = !checked
    }
    return items
  }

  let dialog = null


  onMount(async () => {
    await tick()
    dialog.showModal()
  })
  onDestroy(()=> {
    dialog.close()
  })
</script>

<DialogBase2 bind:dialog={dialog}>
  <DialogTitle>
    {translate("generic.filterShort")}:
    {#if targetTranslationKey}
      {translate(targetTranslationKey)}
    {:else}
      {target}
    {/if}
  </DialogTitle>
  <DialogSplitter />
  <DialogContent>
    <div style="display: flex; flex-direction: column; gap: 1rem">
      <SearchInput bind:value={query}/>
      <div style="display: flex; gap: .5rem;">
        <button class="text-button" on:click={() => filteredItems = setCheckedStates(filteredItems, true)}>
          {translate("frontend:filters.selectAll")}
        </button>
        <div style="width: 1px; background-color: darkgrey;"></div>
        <button class="text-button" on:click={() => filteredItems = setCheckedStates(filteredItems, false)}>
          {translate("frontend:filters.deselectAll")}
        </button>
      </div>
      <div class="filter-items-container">
        {#each filteredItems as filteredItem}
          <button class="filter-item-button" on:click={() => filteredItem.excluded = !filteredItem.excluded}>
            {#if isChecked(filteredItem)}
              <img src="/assets/icons/checkbox_on.svg" alt="checkbox on icon" />
            {:else}
              <img src="/assets/icons/checkbox_off.svg" alt="checkbox off icon" />
            {/if}
            <span>
              {#if filteredItem.text}
                {filteredItem.text}
              {:else}
                {translate("frontend:filters.blankTextLabel")}
              {/if}
            </span>
          </button>
        {/each}
      </div>
    </div>
  </DialogContent>
  <DialogSplitter />
  <DialogBottomControls>
    <DialogBottomControlButton onClick={() => onFilterDetermined(items)}>
      OK
    </DialogBottomControlButton>
    <DialogBottomControlButton type="secondary" onClick={onClose}>
      {translate("generic.cancel")}
    </DialogBottomControlButton>
  </DialogBottomControls>
</DialogBase2>

<style>
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
  .text-button {
    color: #00468f;
    font-weight: bold;
    font-size: .9rem
  }
  .filter-items-container {
    border-top: solid 1px #cccccc;
    display: flex;
    flex-direction: column;
    gap: .5rem;
    padding: .5rem;
    height: 200px;
    overflow-y: auto;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    margin-bottom: -24px;
  }
  .filter-item-button {
    display: inline-flex;
    gap: .5rem;
    flex-wrap: nowrap;
  }
  .filter-item-button img {
    width: 1rem
  }
  .filter-item-button span {
    flex: 1;
    text-align: start;
    pointer-events: none;
  }
</style>
